export default "__VITE_ASSET__DfU1u8ul__"